import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=0a2b3a12"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports